import Colors from "../../core/Colors";
import { handleKeyOnClick } from "../input/keyOnClick";
import { ComponentF, ComponentO, createElement } from "../ui";

const TabHeader: ComponentF<{
  title: string;
  keys: string;
  selected: boolean;
  onClick: () => void;
}> = (C, props) => {
  const firstKey = Array.isArray(props.keys) ? props.keys[0] : props.keys;

  const [state, setState] = C.useState({ hover: false });
  const color =
    props.selected || state.hover ? Colors.B_GREY_5 : Colors.B_GREY_3;
  if (firstKey) {
    C.display.drawText(
      C.bounds.x,
      C.bounds.y,
      `%c{${Colors.RED_4}}${firstKey}`
    );
  }
  C.display.drawText(
    C.bounds.x + (firstKey ? 1 : 0),
    C.bounds.y,
    `%c{${color}}${props.title}`
  );
  C.handlers.hover = () => {
    setState({ hover: true });
  };
  C.handlers.out = () => {
    setState({ hover: false });
  };

  C.handlers.press = () => {
    props.onClick();
  };

  handleKeyOnClick(C, props);
};

const TabContents: ComponentF<{ children: ComponentO[] }> = (C, props) => {
  return props.children;
};
export const TabbedContents: ComponentF<{
  children: { title: string; keys: string | string[]; value: ComponentO }[];
}> = (C, { children }) => {
  const [state, setState] = C.useState({ selected: 0 });

  let left = 0;
  const tabList = children.map((tab, index) => {
    const tWidth = tab.title.length + (tab.keys ? 2 : 1);

    const tabElement = createElement(
      TabHeader,
      {
        x: left,
        y: 0,
        w: tWidth,
        h: 1,
      },
      {
        selected: index === state.selected,
        title: tab.title,
        keys: tab.keys,
        onClick: () => setState({ selected: index }),
      }
    );
    left += tWidth;
    return tabElement;
  });

  return [
    ...tabList,
    createElement(
      TabContents,
      { x: 0, y: 2, w: C.bounds.w, h: C.bounds.h - 2 },
      {
        children: [
          children[state.selected < children.length ? state.selected : 0].value,
        ],
      }
    ),
  ];
};
